import { Injectable } from '@angular/core';
import { GrowthBookService } from "@services/growthbook/growthbook.service";
import { HttpParams } from "@angular/common/http";

@Injectable({
  providedIn: 'root'
})
export class AbandonedCartService {
  constructor(private gbs: GrowthBookService) {}

  public createHttpParamsWithAbandonedCartVariant()
  {
    return new HttpParams().set('abandonedCartVariant', this.gbs.getFeatureVariant('feat-001220-abandoned-cart', ''));
  }
}
